/*
 * PONGO stage layout (main-product, "PONGO stage layout" setting).
 * - Gallery: one image at a time, arrows + thumbnails on desktop, swipe + dots on phones,
 *   filtered to the selected finish (shared images always show). Click an image to zoom.
 * - Swatches and set cards: set the theme's own hidden option selects, so the theme still
 *   handles price, stock, cart and checkout. We listen for its 'cc-variant-updated' event to sync.
 */
(function () {
  'use strict';

  // The theme loads jQuery with defer after this script, so it's picked up when we start (see the bottom).
  var $ = null;

  function moneyNoZeros(cents) {
    var format = (window.theme && theme.money_format) || '${{amount}}';
    format = format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, cents % 100 === 0 ? '{{amount_no_decimals}}' : '{{amount}}');
    if (window.theme && theme.Shopify && theme.Shopify.formatMoney) {
      return theme.Shopify.formatMoney(cents, format);
    }
    return '$' + (cents % 100 === 0 ? cents / 100 : (cents / 100).toFixed(2));
  }

  function initGallery(stage) {
    var track = stage.querySelector('[data-pongo-track]');
    var slides = Array.prototype.slice.call(stage.querySelectorAll('[data-pongo-slide]'));
    var thumbs = Array.prototype.slice.call(stage.querySelectorAll('[data-pongo-thumb]'));
    var dots = stage.querySelector('[data-pongo-dots]');
    var count = stage.querySelector('[data-pongo-count]');
    var tag = stage.querySelector('[data-pongo-tag]');
    var zoom = stage.querySelector('[data-pongo-zoom]');
    var zoomImg = stage.querySelector('[data-pongo-zoom-img]');
    var current = 0;

    function visible() {
      return slides.filter(function (s) { return !s.hidden; });
    }

    function render() {
      var vis = visible();
      var visThumbs = thumbs.filter(function (t) { return !t.hidden; });
      if (current > vis.length - 1) current = Math.max(0, vis.length - 1);
      count.textContent = vis.length ? (current + 1) + ' / ' + vis.length : '';
      visThumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === current ? 'true' : 'false'); });
      Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-on', i === current); });
      var finish = vis[current] ? vis[current].getAttribute('data-finish') : '';
      tag.textContent = finish;
      tag.hidden = !finish;
      stage.classList.toggle('is-single', vis.length < 2);
      var activeThumb = visThumbs[current];
      if (activeThumb && activeThumb.parentNode.scrollWidth > activeThumb.parentNode.clientWidth) {
        var strip = activeThumb.parentNode;
        var left = activeThumb.offsetLeft - (strip.clientWidth - activeThumb.offsetWidth) / 2;
        strip.scrollTo({ left: left, behavior: 'smooth' });
      }
    }

    function go(i, smooth) {
      var vis = visible();
      if (!vis.length) return;
      current = (i + vis.length) % vis.length;
      track.scrollTo({ left: vis[current].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      render();
    }

    function buildDots() {
      dots.innerHTML = visible().map(function () { return '<i></i>'; }).join('');
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var w = track.clientWidth;
        if (!w) return;
        var i = Math.round(track.scrollLeft / w);
        if (i !== current) {
          current = i;
          render();
        }
      });
    }, { passive: true });

    stage.querySelector('[data-pongo-prev]').addEventListener('click', function () { go(current - 1); });
    stage.querySelector('[data-pongo-next]').addEventListener('click', function () { go(current + 1); });

    stage.querySelector('[data-pongo-thumbs]').addEventListener('click', function (e) {
      var t = e.target.closest('[data-pongo-thumb]');
      if (!t) return;
      var visThumbs = thumbs.filter(function (x) { return !x.hidden; });
      go(visThumbs.indexOf(t));
    });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
    });

    // Zoom: full-size image in a dialog
    if (zoom && typeof zoom.showModal === 'function') {
      track.addEventListener('click', function (e) {
        var slide = e.target.closest('[data-pongo-slide]');
        var img = slide && slide.querySelector('img');
        if (!img) return;
        // Show the image already on screen straight away, then swap in the full-size one once it's loaded
        zoomImg.src = img.currentSrc || img.src;
        zoomImg.alt = img.alt;
        var full = new Image();
        full.onload = function () { if (zoom.open) zoomImg.src = full.src; };
        full.src = slide.getAttribute('data-full');
        zoom.showModal();
      });
      zoom.addEventListener('click', function () { zoom.close(); });
    }

    function setFinish(finish) {
      if (!finish || stage.getAttribute('data-current-finish') === finish) return;
      stage.setAttribute('data-current-finish', finish);
      slides.concat(thumbs).forEach(function (el) {
        var f = el.getAttribute('data-finish');
        el.hidden = !!f && f !== finish;
      });
      buildDots();
      // Jump to the finish's first image (shared photos may come before it, e.g. the Permanent's installs)
      var first = visible().map(function (s) { return s.getAttribute('data-finish'); }).indexOf(finish);
      go(first > -1 ? first : 0, false);
    }

    buildDots();
    render();
    return { setFinish: setFinish };
  }

  // "Get a quote": the dialog form, kept in step with the chosen options
  function initQuote(area, opts) {
    var dialog = area.querySelector('[data-pongo-quote-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return null;
    var summary = dialog.querySelector('[data-pongo-quote-summary]');
    var optionsField = dialog.querySelector('[data-pongo-quote-options]');
    var priceEl = dialog.querySelector('[data-pongo-quote-price]');
    var barPrice = area.querySelector('[data-pongo-bar-price]');
    var pair = dialog.querySelector('[data-pongo-quote-pair]');
    var hasPriceLabel = !!area.querySelector('.pongo-price');

    function open() {
      dialog.showModal();
      var field = dialog.querySelector('input:not([type=hidden]), select, textarea');
      if (field) field.focus();
    }

    area.addEventListener('click', function (e) {
      if (!e.target.closest('[data-pongo-quote-open]')) return;
      e.preventDefault();
      open();
    });
    // Close buttons (the thank-you adds one), and a click on the backdrop outside the panel
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog || e.target.closest('[data-pongo-quote-close]')) dialog.close();
    });

    // Remember what they typed, in this tab only, so the thank-you after Shopify's reload can use it
    var KEY = 'pongo-quote';
    var form = dialog.querySelector('form');
    if (form) {
      form.addEventListener('submit', function () {
        var val = function (q) { var el = form.querySelector('[data-pongo-q="' + q + '"]'); return el ? el.value.trim() : ''; };
        var extras = [];
        Array.prototype.forEach.call(form.querySelectorAll('[data-pongo-q-extra]'), function (el) {
          if (el.tagName === 'SELECT') extras.push(el.getAttribute('data-pongo-q-extra') + ': ' + el.value);
          else if (el.checked) extras.push(el.getAttribute('data-pongo-q-extra'));
        });
        try {
          sessionStorage.setItem(KEY, JSON.stringify({
            name: val('name').split(/\s+/)[0], email: val('email'), org: val('org'), postcode: val('postcode'),
            qty: parseInt(val('qty'), 10) || 1, options: summary ? summary.textContent : '', extras: extras,
          }));
        } catch (err) { /* private mode: the thank-you just isn't personalised */ }
      });
    }

    // Shopify only emails the store contact address, so (with Taylor's OK, 2026-11-03) a copy also goes to
    // "Also email a copy to" via FormSubmit. Sent without waiting (keepalive survives the page navigating away),
    // so Shopify's own submit and spam check run as normal; if FormSubmit fails, the Shopify email still goes.
    var copyTo = dialog.getAttribute('data-pongo-copy-to');
    if (copyTo && form) {
      form.addEventListener('submit', function () {
        var data = new URLSearchParams();
        new FormData(form).forEach(function (value, key) {
          if (typeof value !== 'string' || !value || /^(form_type|utf8|h-captcha-response|g-recaptcha-response)$/.test(key)) return;
          var label = key.replace(/^contact\[(.*)\]$/, '$1');
          data.append(label === 'body' ? 'Message' : label, value);
        });
        var email = form.querySelector('[data-pongo-q="email"]');
        if (email && email.value) data.append('_replyto', email.value);
        if (dialog.getAttribute('data-pongo-copy-cc')) data.append('_cc', dialog.getAttribute('data-pongo-copy-cc'));
        data.append('_subject', 'New quote request: ' + (dialog.getAttribute('data-pongo-product') || 'PONGO'));
        data.append('_template', 'table');
        data.append('_captcha', 'false');
        try {
          fetch('https://formsubmit.co/ajax/' + encodeURIComponent(copyTo), { method: 'POST', body: data, mode: 'no-cors', keepalive: true });
        } catch (err) { /* the Shopify email still goes out */ }
      });
    }

    function confetti(box) {
      if (!box || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var colors = ['#3fa9f5', '#0abf00', '#e6a8e7', '#f27949', '#ffd110'];
      for (var i = 0; i < 28; i++) {
        var p = document.createElement('i');
        var ang = Math.PI * (0.05 + 0.9 * (i / 27));
        var dist = 120 + (i * 37) % 110;
        p.style.background = colors[i % colors.length];
        p.style.setProperty('--dx', Math.round(Math.cos(ang) * dist * (i % 2 ? 1 : -1) * 1.4) + 'px');
        p.style.setProperty('--dy', Math.round(Math.sin(ang) * dist * 0.7 - 30) + 'px');
        p.style.setProperty('--r', ((i * 53) % 360) + 'deg');
        p.style.animationDelay = ((i % 5) * 0.03) + 's';
        if (i % 3 === 0) p.style.borderRadius = '50%';
        box.appendChild(p);
      }
    }

    function showThanks() {
      var tpl = dialog.querySelector('[data-pongo-quote-thanks]');
      var ask = dialog.querySelector('[data-pongo-quote-ask]');
      if (!tpl || !ask) return;
      var d = {};
      try { d = JSON.parse(sessionStorage.getItem(KEY) || '{}') || {}; sessionStorage.removeItem(KEY); } catch (err) { d = {}; }
      var node = tpl.content.firstElementChild.cloneNode(true);
      var set = function (sel, text) { var el = node.querySelector(sel); if (el) el.textContent = text; };
      set('[data-pongo-thanks-title]', 'Legend' + (d.name ? ', ' + d.name : '') + '! Your request is in.');
      set('[data-pongo-thanks-for]', 'Thanks for thinking of PONGO' + (d.org ? ' for ' + d.org : '') + '.');
      var chosen = (d.options || '').split(' · ').map(function (s) { return s.split(': ').pop(); }).filter(Boolean);
      if (chosen.length) set('[data-pongo-thanks-product]', node.querySelector('[data-pongo-thanks-product]').textContent + ' · ' + chosen.join(' · '));
      var recap = [(d.qty || 1) + ((d.qty || 1) === 1 ? ' table' : ' tables')];
      if (d.postcode) recap.push('delivery to ' + d.postcode);
      set('[data-pongo-thanks-recap]', recap.concat(d.extras || []).join(' · '));
      Array.prototype.forEach.call(node.querySelectorAll('[data-pongo-thanks-fill]'), function (el) {
        el.textContent = el.textContent.replace(/\{postcode\}/g, d.postcode || 'you').replace(/\{email\}/g, d.email || 'you');
      });
      node.querySelector('h2').id = dialog.getAttribute('aria-labelledby');
      ask.replaceWith(node);
      if (!dialog.open) dialog.showModal();
      confetti(node.querySelector('.pongo-quote__burst'));
    }

    // After sending (or a mistake), Shopify reloads the page: show the result straight away.
    // #pongo-quote-thanks on the link previews the thank-you without sending anything.
    if (dialog.querySelector('[data-pongo-quote-posted]') || location.hash === '#pongo-quote-thanks') {
      // Count the LinkedIn conversion (snippets/pongo-linkedin.liquid) only for a real send from this tab:
      // showThanks clears the saved details, so a refresh or the preview link doesn't count again.
      var sent = false;
      try { sent = !!dialog.querySelector('[data-pongo-quote-posted]') && !!sessionStorage.getItem(KEY); } catch (err) {}
      showThanks();
      var li = window.pongoLinkedIn;
      if (sent && li && li.quoteConversion && window.lintrk) window.lintrk('track', { conversion_id: li.quoteConversion });
    }
    else if (dialog.querySelector('[data-pongo-quote-errors]')) open();

    if (document.querySelector('.pongo-quote-bar')) document.body.classList.add('pongo-has-quote-bar');

    return {
      sync: function (variant) {
        var parts = [];
        if (opts) {
          Array.prototype.forEach.call(opts.querySelectorAll('.pongo-opt'), function (group) {
            var checked = group.querySelector('[aria-checked="true"]');
            if (checked) parts.push(group.getAttribute('data-name') + ': ' + (checked.getAttribute('data-label') || checked.getAttribute('data-value')));
          });
        }
        if (summary) summary.textContent = parts.join(' · ');
        if (optionsField) optionsField.value = parts.join(', ');
        if (!hasPriceLabel) {
          if (priceEl) priceEl.textContent = moneyNoZeros(variant.price);
          if (barPrice) barPrice.textContent = moneyNoZeros(variant.price);
        }
        if (pair) {
          var needsPair = variant.options.indexOf(pair.getAttribute('data-pongo-quote-pair')) > -1;
          pair.hidden = !needsPair;
          Array.prototype.forEach.call(pair.querySelectorAll('select'), function (sel) {
            sel.disabled = !needsPair;
            sel.required = needsPair;
          });
        }
      }
    };
  }

  function initArea(area) {
    if (area.getAttribute('data-pongo-init')) return;
    area.setAttribute('data-pongo-init', 'true');

    var dataEl = document.getElementById('cc-product-json-' + area.getAttribute('data-product-id'));
    var product = dataEl ? JSON.parse(dataEl.textContent) : null;
    var stageEl = area.querySelector('[data-pongo-stage]');
    var gallery = stageEl ? initGallery(stageEl) : null;
    var finishIndex = stageEl ? parseInt(stageEl.getAttribute('data-finish-index'), 10) : -1;
    var opts = area.querySelector('[data-pongo-opts]');
    var addLabel = (window.theme && theme.strings && theme.strings.buttonDefault) || 'Add to Cart';

    var quote = initQuote(area, opts);

    function themeSelect(index) {
      return area.querySelectorAll('.option-selectors select')[index];
    }

    function findVariant(options) {
      if (!product) return null;
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        if (v.options.every(function (o, k) { return o === options[k]; })) return v;
      }
      return null;
    }

    function sync(variant) {
      if (!variant) return;

      if (opts) {
        Array.prototype.forEach.call(opts.querySelectorAll('[data-pongo-index]'), function (btn) {
          var index = parseInt(btn.getAttribute('data-pongo-index'), 10);
          var value = btn.getAttribute('data-value');
          btn.setAttribute('aria-checked', variant.options[index] === value ? 'true' : 'false');

          if (!btn.classList.contains('pongo-card')) return;
          var options = variant.options.slice();
          options[index] = value;
          var cardVariant = findVariant(options);
          var priceEl = btn.querySelector('[data-pongo-price]');
          var saveEl = btn.querySelector('[data-pongo-save]');
          btn.classList.toggle('is-unavailable', !cardVariant || !cardVariant.available);
          if (cardVariant && priceEl) priceEl.textContent = moneyNoZeros(cardVariant.price);

          var bundle = parseInt(btn.getAttribute('data-bundle'), 10) || 0;
          var saving = 0;
          if (bundle > 0 && cardVariant && product) {
            var unit = product.variants.filter(function (v) {
              return v.options[index] !== value && v.options.every(function (o, k) { return k === index || o === options[k]; });
            })[0];
            if (unit) saving = unit.price * bundle - cardVariant.price;
          }
          if (saveEl) {
            saveEl.hidden = saving <= 0;
            saveEl.textContent = 'Save ' + moneyNoZeros(saving);
          }
        });

        Array.prototype.forEach.call(opts.querySelectorAll('[data-pongo-selected]'), function (el) {
          var index = parseInt(el.getAttribute('data-pongo-selected'), 10);
          var checked = opts.querySelector('.pongo-swatch[data-pongo-index="' + index + '"][aria-checked="true"]');
          el.textContent = checked ? checked.getAttribute('data-label') : variant.options[index];
        });
      }

      if (quote) quote.sync(variant);

      // "Save $X" next to the main price when a bundle card is selected
      var priceArea = area.querySelector('.price-area');
      var selectedCard = opts && opts.querySelector('.pongo-card[aria-checked="true"] [data-pongo-save]:not([hidden])');
      if (priceArea) {
        var pill = priceArea.querySelector('.pongo-save-pill');
        if (pill) pill.remove();
        if (selectedCard) {
          pill = document.createElement('span');
          pill.className = 'pongo-save-pill';
          pill.textContent = selectedCard.textContent;
          priceArea.appendChild(pill);
        }
      }

      // Price in the Add to cart buttons (main and the phone sticky bar)
      if (variant.available && area.getAttribute('data-is-preorder') !== 'true') {
        Array.prototype.forEach.call(area.querySelectorAll('.product-purchase-form [type=submit]:not(.adding), .product-area__add-to-cart-xs button'), function (btn) {
          btn.textContent = addLabel + ' · ' + moneyNoZeros(variant.price);
        });
      }

      if (gallery && finishIndex > -1) gallery.setFinish(variant.options[finishIndex]);
    }

    if (opts) {
      opts.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-pongo-index]');
        if (!btn) return;
        var select = themeSelect(parseInt(btn.getAttribute('data-pongo-index'), 10));
        if (!select) return;
        select.value = btn.getAttribute('data-value');
        if ($) {
          $(select).trigger('change');
        } else {
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      // Arrow keys move between options in a group (radio behaviour)
      opts.addEventListener('keydown', function (e) {
        if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(e.key) < 0) return;
        var btn = e.target.closest('[data-pongo-index]');
        if (!btn) return;
        var group = Array.prototype.slice.call(btn.parentNode.querySelectorAll('[data-pongo-index]'));
        var step = e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 1;
        var next = group[(group.indexOf(btn) + step + group.length) % group.length];
        e.preventDefault();
        next.focus();
        next.click();
      });
    }

    if ($) {
      $(window).on('cc-variant-updated', function (e, data) {
        if (data && data.product && product && data.product.id !== product.id) return;
        if (data && data.variant) sync(data.variant);
      });
    }

    // Initial state, in case the theme's first-run event fired before this script loaded
    var idInput = area.querySelector('.product-purchase-form [name="id"]') || area.querySelector('[name="id"]');
    if (idInput && product) {
      var initial = product.variants.filter(function (v) { return String(v.id) === String(idInput.value); })[0];
      if (initial) sync(initial);
    }
  }

  function initAll() {
    $ = window.jQuery || null;
    Array.prototype.forEach.call(document.querySelectorAll('.product-area--stage'), initArea);
  }

  // DOMContentLoaded fires after every deferred script (jQuery, theme.js) has run, and before the theme
  // initialises the product form, so we catch its first 'cc-variant-updated' event. 'load' covers late injection.
  if (document.readyState === 'complete') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
    window.addEventListener('load', initAll);
  }
  document.addEventListener('shopify:section:load', initAll);
})();
